import { render, staticRenderFns } from "./dashboard-header.vue?vue&type=template&id=3698e39c&scoped=true&"
import script from "./dashboard-header.vue?vue&type=script&lang=js&"
export * from "./dashboard-header.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-header.vue?vue&type=style&index=0&id=3698e39c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3698e39c",
  null
  
)

export default component.exports